import { useEffect } from 'react';
import {
  ComponentTypesActions,
  useContentDispatch,
  useContentSelector,
  getCollectionComponentTypeByIdMultilingual,
} from '@wajeez-web/stores/content';
import { Spin } from '@wajeez-web/components/ui';
import { useParams } from 'react-router-dom';
import { useGetCollectionComponentTypeByIdMultilingual } from '@wajeez-web/components/helpers';

import { CollectionComponentTypeCreateForm } from './CollectionComponentTypeCreateForm';
import { CollectionComponentTypeCreateFormWithPrefilledData } from './CollectionComponentTypeCreateFormWithPrefilledData';
import { CollectionComponentTypeEditForm } from './CollectionComponentTypeEditForm';

interface CollectionComponentTypeFormProps {
  type: 'Create' | 'CreateWithPrefilledData' | 'Edit';
  onSubmit: (collectionComponentTypeId: number) => void;
  onCancel: () => void;
}

export const CollectionComponentTypeForm = ({
  type,
  onSubmit,
  onCancel,
}: CollectionComponentTypeFormProps) => {
  const { id } = useParams<{ id: string }>();

  const contentDispatch = useContentDispatch();

  const componentTypesLookups = useContentSelector(
    ({ componentTypes }) => componentTypes.componentTypesLookups
  );

  const collectionComponentTypeByIdMultilingual =
    useGetCollectionComponentTypeByIdMultilingual();

  useEffect(() => {
    contentDispatch(ComponentTypesActions.getComponentTypesLookupsAsync());
  }, []);

  useEffect(() => {
    if (id) {
      getCollectionComponentTypeByIdMultilingual(Number(id));
    }
  }, [id]);

  return componentTypesLookups.status === 'loading' ? (
    <Spin />
  ) : (
    <div className="relative w-[800px] mx-auto">
      {type === 'Create' ? (
        <CollectionComponentTypeCreateForm
          onSubmit={onSubmit}
          onCancel={onCancel}
        />
      ) : collectionComponentTypeByIdMultilingual.status === 'loading' ? (
        <Spin />
      ) : type === 'CreateWithPrefilledData' ? (
        <CollectionComponentTypeCreateFormWithPrefilledData
          onSubmit={onSubmit}
          onCancel={onCancel}
        />
      ) : (
        <CollectionComponentTypeEditForm
          onSubmit={onSubmit}
          onCancel={onCancel}
        />
      )}
    </div>
  );
};
